module.exports = __webpack_public_path__ + "static/img/bg5.a7d00f43.png";